.top-categories {
  background-color: #f7f7f7;
  box-sizing: border-box;
}

.top-categories *,
.top-categories *::before,
.top-categories *::after {
  box-sizing: inherit;
}

@media screen and (max-width: 979px) {
  .top-categories {
    margin: 0 auto;
    padding: 0 0 24px;
    min-height: 208px;
  }
}

@media screen and (min-width: 980px) {
  .top-categories {
    margin: 0;
    margin-top: 4px;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
}

.top-categories__slider {
  width: 100%;
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .top-categories__slider {
    padding: 0 0 20px 12px;
  }

  :host([dir="rtl"]) .top-categories__slider {
    padding: 0 12px 20px 0;
  }
}

.top-categories__action-block {
  display: block;
  height: calc(50% - 10px);
}

.top-categories__action-block + .top-categories__action-block {
  margin-top: 20px;
}

.top-categories__action-block:only-child {
  height: 100%;
}

@media screen and (min-width: 980px) {
  .top-categories__card {
    width: 25%;
    max-width: 300px;
    height: 300px;
    padding: 10px;
  }
}

@media screen and (min-width: 980px) {
  .top-categories__card--large {
    width: 50%;
    max-width: 600px;
  }
}